import { ListMenuCardAction } from '../constant'
import Form from './form.vue'
import { useDetector } from '~/hooks/useDetector'
import { useEmptyModal } from '~/hooks/useModal/modals/empty'
import { PageKey } from '~/constants/page'

export function usePublishAction(scene: 'personal' | 'team') {
  const { isTeamRight, isAdmin, isVerified } = useDetector()
  const router = useRouter()
  const { $t } = useNuxtApp()
  const { hasActionPermission } = usePageAndActionPermissionData()
  // MenuItem 是否可见
  const isShow = computed(() => {
    if (scene === 'personal') {
      return !isTeamRight.value
    }
    if (scene === 'team') {
      return (
        isTeamRight && hasActionPermission('team_space_publish_to_platform')
      )
    }
    return false
  })

  const checkPermission = () => {
    if (scene === 'team') {
      // 判断是否是管理员
      if (!isAdmin.value) {
        message.warn(
          $t(
            'jin-guan-li-yuan-ke-fa-bu-cheng-pian-zhi-you-yan-ping-tai-qing-lian-xi-guan-li-yuan-fa-bu-cheng-pian'
          )
        )
        return false
      }
      if (!isVerified.value && !isGlobalVersion()) {
        message.warn(
          <div>
            {$t(
              'qing-wan-cheng-tuan-dui-ren-zheng-hou-fa-bu-cheng-pian-zhi-you-yan-ping-tai'
            )}
            <a
              class={'ml-[4px]'}
              onClick={() => {
                router.push({
                  name: PageKey.ACCOUNT_VERIFY,
                })
              }}
            >
              {$t('qu-ren-zheng')}
            </a>
          </div>
        )
        return false
      }
    }
    return true
  }

  const model = ref()

  const resourceLocation =
    scene === 'personal' ? SOURCE.PERSONAL_PAGE : SOURCE.TEAM_SPACE

  const action = (data: any) => {
    if (!checkPermission()) {
      return false
    }

    trackEvent(TRACK_EVENT.CLICK_PUBLISH_TO_YOUYAN_PLATFORM, {
      source: resourceLocation,
      ev_name: data.title,
      ev_id: data.id,
    })

    model.value = useEmptyModal({
      closable: false,
      width: 688,
      content: (
        <Form onClose={() => model.value.destroy()} data={data} scene={scene} />
      ),
    })
  }

  return {
    isShow,
    action,
    type: ListMenuCardAction.PUBLISH,
    destroy: () => {
      model.value?.destroy()
    },
  }
}
